import { jsx as a, jsxs as E, Fragment as S } from "react/jsx-runtime";
import P, { useState as s, useRef as k, useEffect as _, Suspense as $ } from "react";
import { r as A } from "../../index-DC7FmJPK.mjs";
import { classes as L } from "../../utils/helpers.js";
import { blockLayoutsMap as w } from "../../settings.js";
import { X as F } from "../../x-D8_C2o-U.mjs";
import '../../assets/ModalContainer.css';const K = "_modal_1vlfz_1", M = "_reveal_1vlfz_1", N = "_hide_1vlfz_1", v = {
  modal: K,
  reveal: M,
  hide: N,
  "backdrop-reveal": "_backdrop-reveal_1vlfz_1",
  "modal__close-btn": "_modal__close-btn_1vlfz_48"
}, R = (r) => {
  if (!document.querySelector(`#${r}`)) {
    const t = document.createElement("div");
    t.setAttribute("id", r), document.querySelector("body").append(t);
  }
};
function G({
  contentComponent: r = "BCVideoPlayer",
  airaLabel: h = "",
  modalId: t = "modal-container",
  onModalClose: x = () => !0,
  children: u
}) {
  const [d, B] = s(null), [z, g] = s("entering"), [y, b] = s(!1), [c, p] = s(null), [D, f] = s(!1), o = k(null), C = k(null), m = () => {
    g("exiting"), b(!0), o.current !== null && setTimeout(() => {
      o.current.close(), b(!1), g("entering"), x();
    }, 750);
  }, i = (e) => {
    [...o.current.attributes].findIndex((n) => n.name === "open") !== -1 && e.key === "Escape" && (e.preventDefault(), e.stopPropagation(), m());
  }, O = (e) => {
    e.target.classList.contains(`${v.modal}`) && m();
  };
  return R(t), _(() => {
    document.getElementById(t).removeEventListener(`scripps:${t.replaceAll("-", "")}:change`, (n) => {
      p(n.detail.componentProps), n.detail.forceOpen && f((l) => !l);
    });
    async function e() {
      B(w.get(r));
    }
    return r !== "" && e(), document.getElementById(t).addEventListener(`scripps:${t.replaceAll("-", "")}:change`, (n) => {
      p(n.detail.componentProps), n.detail.forceOpen && f((l) => !l);
    }), () => {
      document.getElementById(t).removeEventListener(`scripps:${t.replaceAll("-", "")}:change`, (n) => {
        p(n.detail.componentProps), n.detail.forceOpen && f((l) => !l);
      });
    };
  }, [r, t]), _(() => {
    let e = null;
    const n = () => {
      const l = setInterval(() => {
        o.current !== null && (clearInterval(l), e = o.current);
      }, 100);
    };
    return o.current === null && n(), () => {
      e == null || e.close();
    };
  }, [d]), _(() => {
    o.current !== null && [...o.current.attributes].findIndex((e) => e.name === "open") === -1 && c !== null && (o.current.showModal(), C.current.blur());
  }, [c, D]), A.createPortal(
    /* @__PURE__ */ a($, { children: /* @__PURE__ */ E(
      "dialog",
      {
        ref: o,
        "data-state": z,
        className: L([v.modal, "modal"]),
        onKeyDown: i,
        onKeyUp: i,
        onClick: O,
        onCancel: (e) => e.preventDefault(),
        "aria-modal": "true",
        "aria-label": h,
        children: [
          d !== null && u === void 0 && /* @__PURE__ */ a(
            d,
            {
              ...c,
              containerClosing: y,
              handleClosing: i
            }
          ),
          u !== void 0 && /* @__PURE__ */ a(S, { children: P.Children.map(u, (e) => P.cloneElement(e, {
            ...c,
            containerClosing: y,
            handleClosing: i
          })) }),
          /* @__PURE__ */ E(
            "button",
            {
              type: "button",
              onClick: m,
              className: L([v["modal__close-btn"], "modal__close-btn"]),
              "aria-label": "Close",
              ref: C,
              children: [
                /* @__PURE__ */ a("span", { className: "sr-only", children: "close" }),
                /* @__PURE__ */ a("i", { children: /* @__PURE__ */ a(F, { width: "48", height: "48" }) })
              ]
            }
          )
        ]
      }
    ) }),
    document.getElementById(t)
  );
}
export {
  G as ModalContainer,
  G as default
};
